import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

const path   = window.location.pathname;
const params = new URLSearchParams(window.location.search);

// Legacy ?uid= share links — rewrite to /epk/<uid> before rendering anything
if ((path === '/' || path === '') && params.get('uid')) {
  window.location.replace('/epk/' + params.get('uid'));

} else if (path.startsWith('/epk/')) {
  // Public artist EPK page — load PublicEPK without pulling in App.js
  const PublicEPK = React.lazy(() => import('./PublicEPK'));
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={<div style={{ background: '#0a0a0f', minHeight: '100vh' }} />}>
        <PublicEPK />
      </React.Suspense>
    </React.StrictMode>
  );

} else {
  // Normal app path
  import('./App').then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}

reportWebVitals();
registerServiceWorker();
